import styled from "@emotion/styled";
import { Property } from "csstype";

export const ColorNumber = styled.span<{ color?: Property.Color }>(props => ({
    color: props.color ?? "#888",
}));
